<div class="modal-header">
  <h4 class="modal-title pull-left">Editar Datos</h4>
  <button
    type="button"
    class="btn-close pull-right"
    aria-label="Close"
    (click)="modalEditRef.hide()"
    name="modalEditRef"
  >
    <!-- <span aria-hidden="true">&times;</span> -->
  </button>
</div>
<div class="modal-body">
  <form (ngSubmit)="updateProfile()" [formGroup]="formProfile">
    <div class="row">
      <div class="mb-3 col-md-6">
        <label>Nombre (*)</label>
        <input type="text" class="form-control" formControlName="firstName" />
      </div>
      <div class="mb-3 col-md-6">
        <label>Apellido (*)</label>
        <input type="text" class="form-control" formControlName="lastName" />
      </div>
      <div class="mb-3 col-md-6">
        <label>Correo de contacto (*)</label>
        <input type="text" class="form-control" formControlName="email" />
        <p
          *ngIf="
            formProfile.controls['email'].invalid &&
            formProfile.controls['email'].touched
          "
          class="text-error-form-2"
        >
          El correo ingresado no es válido.
        </p>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label>Teléfono (*)</label>
          <div class="input-group">
            <!-- <div class="input-group-prepend">
            <span class="input-group-text">{{
              config.phoneCodes.mobile.code
            }}</span>
          </div> -->
            <div class="input-group-prepend" dropdown>
              <button
                id="button-basic"
                dropdownToggle
                type="button"
                class="btn btn-outline-secondary dropdown-toggle"
                aria-controls="dropdown-phone"
              >
                <i
                  [ngClass]="
                    selectedPhoneCode == this.config.phoneCodes.mobile.code
                      ? 'fa-solid fa-mobile-screen'
                      : 'fa-solid fa-phone'
                  "
                  style="margin-right: 1px"
                ></i>
                {{ selectedPhoneCode }}
              </button>
              <div
                id="dropdown-phone"
                *dropdownMenu
                class="dropdown-menu"
                role="menu"
                aria-labelledby="button-basic"
              >
                <a
                  class="dropdown-item"
                  (click)="selectPhoneCode(this.config.phoneCodes.mobile.code)"
                  ><i
                    class="fa-solid fa-mobile-screen"
                    style="margin-right: 1px"
                  ></i
                  >{{ this.config.phoneCodes.mobile.code }}</a
                >
                <a
                  class="dropdown-item"
                  (click)="
                    selectPhoneCode(this.config.phoneCodes.landline.code)
                  "
                  ><i class="fa-solid fa-phone" style="margin-right: 1px"></i
                  >{{ this.config.phoneCodes.landline.code }}</a
                >
              </div>
            </div>
            <input
              formControlName="phone"
              type="text"
              class="form-control"
              placeholder="Teléfono*"
              [maxLength]="phoneLength"
              (input)="noCharPhone($event)"
            />
          </div>

          @if ( formProfile.controls['phone'].invalid &&
          formProfile.controls['phone'].touched ) {
          <p class="text-error-form-2">El Teléfono ingresado no es válido.</p>
          }
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button
    class="btn btn-danger"
    (click)="modalEditRef.hide()"
    name="modalEditRef2"
  >
    Cancelar
  </button>
  <button
    class="btn btn-secondary"
    (click)="updateProfile()"
    name="editarPerfil"
    [disabled]="!formProfile.valid"
  >
    Actualizar
  </button>
</div>
